export default "__VITE_PUBLIC_ASSET__a43954c3__"